export default class OrderCsvGenerator {
  constructor(config) {
    this.$container = config.$container;
    this.zipUrl = undefined;
    this.contactFileName = undefined;
    this.exportId = config.exportId;
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    this.$container.hide();
    this.pollEndpoint();
  }

  pollEndpoint() {
    if (this.zipUrl) {
      if (this.$container.is(":visible")) return;

      console.log(this.count)
      $('#loading-message').hide();
      this.$container.show();
      $('#contact-length').html(this.count);

      return;
    }

    $.get(`/admin/orders/waiting.json?export_id=${this.exportId}`, (data) => {
      if (data.chunked) {
        this.handleChunkedResponse(data);
      } else {
        this.handleSingleResponse(data);
      }
    });
  }

  handleSingleResponse(data) {
    this.zipUrl = data.url;
    this.fileName = data.file_name;
    this.count = data.count;

    // Update progress display if image export is in progress
    if (data.progress && data.progress.total_images) {
      const $progress = $('#progress-info');
      $progress.show();
      $('#total-orders').text(data.progress.total_orders);
      $('#total-images').text(data.progress.total_images);
      $('#images-processed').text(data.progress.images_processed || 0);

      const pct = Math.round(((data.progress.images_processed || 0) / data.progress.total_images) * 100);
      $('#progress-bar').css('width', pct + '%');
    }

    setTimeout(this.pollEndpoint.bind(this), 2500);
  }

  handleChunkedResponse(data) {
    $('#loading-message').text('Processing order chunks...');
    $('#chunks-container').show();
    $('#chunks-total').text(data.total_chunks);

    const readyCount = data.chunks.filter(c => c.ready).length;
    $('#chunks-ready').text(readyCount);

    const $list = $('#chunks-list');
    $list.empty();

    data.chunks.forEach((chunk) => {
      const num = chunk.chunk_index + 1;
      const label = num === 1
        ? `Chunk ${num} of ${data.total_chunks} (includes full CSVs)`
        : `Chunk ${num} of ${data.total_chunks}`;

      if (chunk.ready) {
        $list.append(`<div style="margin: 8px 0; padding: 8px; background: #e8f5e9; border-radius: 4px;">
          <span style="color:green;">&#10003;</span> ${label} &mdash;
          <a href="/admin/orders/download_zip.csv?export_id=${chunk.export_id}"><strong>Download</strong></a>
        </div>`);
      } else {
        let progressText = 'Generating envelopes...';
        if (chunk.progress && chunk.progress.total_images) {
          const processed = chunk.progress.images_processed || 0;
          const pct = Math.round((processed / chunk.progress.total_images) * 100);
          progressText = `Images: ${processed} / ${chunk.progress.total_images} (${pct}%)`;
        } else if (chunk.progress && chunk.progress.stage === 'finalizing') {
          progressText = 'Finalizing ZIP...';
        }
        $list.append(`<div style="margin: 8px 0; padding: 8px; background: #fff3e0; border-radius: 4px;">
          <span style="color:orange;">&#9679;</span> ${label} &mdash; ${progressText}
        </div>`);
      }
    });

    if (data.all_complete) {
      $('#loading-message').text('All chunks ready for download.');
    } else {
      setTimeout(this.pollEndpoint.bind(this), 2500);
    }
  }
}
